module.exports = __webpack_public_path__ + "img/nodata.55718100.svg";